import React, { useState } from "react";
import ProjectList from "components/Datasets/ProjectList";
import LessonsLearned from "components/Datasets/LessonsLearned";
import PoliciesStandards from "components/Datasets/PoliciesStandards";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid2 from "@mui/material/Grid2"; // Import Grid2 for responsive layout
import { useDispatch } from "react-redux";
import { resetFiltersAndSearch } from "../../../redux/searchAndFilter/searchAndFilterSlice";
import { useTranslation } from "react-i18next";
import styles from "./ResourcePage.module.css";

const ResourcePage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    dispatch(resetFiltersAndSearch());
  };

  return (
    <div className={styles.mainContainer}>
      {/* Tabs Container */}
      <div className={styles.tabsContainer}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          centered
          sx={{
            "& .MuiTab-root": { color: "#faf0dc", fontWeight: 600 },
            "& .Mui-selected": {
              color: "#0fe880",
              borderBottom: "2px solid #0fe880",
            },
            "& .MuiTabs-indicator": { backgroundColor: "#0fe880" },
          }}
        >
          <Tab label={t("tabs.projects")} />
          <Tab label={t("tabs.lessonsLearned")} />
          <Tab label={t("tabs.policiesStandards")} />
        </Tabs>
      </div>

      {/* Main Content */}
      <Grid2 container spacing={2} className={styles.contentContainer}>
        {/* Sidebar */}
        <Grid2 item xs={12} sm={4} md={3} className={styles.FilterSidebar}>
          {/* Sidebar content like filters goes here */}
        </Grid2>

        {/* Main content */}
        <Grid2 item xs={12} sm={8} md={9} className={styles.mainContent}>
          {activeTab === 0 && <ProjectList />}
          {activeTab === 1 && <LessonsLearned />}
          {activeTab === 2 && <PoliciesStandards />}
        </Grid2>
      </Grid2>
    </div>
  );
};

export default ResourcePage;
